import { g as getPriceRange } from "../../../../chunks/utils2.js";
const load = async () => {
  const prices = getPriceRange();
  return {
    prices
  };
};
export {
  load
};
